import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import PropTypes from 'prop-types'

import { selectors as NotesSelectors } from 'data/notes'

import PopoverContent from './PopoverContent'
import IconButton from 'components/Utils/IconButton'
import { ShareIcon } from 'components/Utils/Icons'
import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import { Consumer as SharedEventBusContextConsumer } from 'contexts/sharedEventBus'

const enhance = compose(
  connect((state, { noteId }) => ({
    note: NotesSelectors.getNote(state, noteId),
  }))
)

class PublicShare extends Component {
  static propTypes = {
    note: PropTypes.object.isRequired,
  }

  render() {
    const { note } = this.props

    return (
      <SharedEventBusContextConsumer>
        {/* Wrapping with the consumer here because the content of the popover doesn't have access to the context */}
        {eventBusStore => (
          <PopoverOnClick
            position="left"
            align="center"
            content={({ closePopover }) => (
              <PopoverContent
                note={note}
                closePopover={closePopover}
                eventBusStore={eventBusStore}
              />
            )}
          >
            <IconButton
              style={{ marginBottom: 2 }}
              tooltip="Share"
              tooltipPosition="left"
            >
              <ShareIcon size={16} />
            </IconButton>
          </PopoverOnClick>
        )}
      </SharedEventBusContextConsumer>
    )
  }
}

export default enhance(PublicShare)
